import { Button } from "@website/ui/button";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { Header } from "@website/widget/login/components";
import styles from "@website/widget/login/components/password-change-successful-card/password-change-successful-card.module.scss";
import { FC, useCallback } from "react";
import approvedImage from "../../../../assets/images/approved.png";

export const PasswordChangeSuccessfulCard: FC = () => {
  const queryString = "login_step";
  const router = useCompatRouter();
  const onClose = useCallback(() => {
    router?.push(
      router?.pathname,
      { ...router?.query, [queryString]: "password" },
      { shallow: true, scroll: false }
    );
  }, [router]);

  return (
    <div className={styles["container"]}>
      <Header onClose={onClose} />
      <div className={styles["image-container"]}>
        <img
          alt="تیک سبز"
          height={approvedImage.height}
          src={approvedImage.src}
          width={approvedImage.width}
        />
      </div>
      <div className={styles["info"]}>رمز عبور شما با موفقیت تغییر کرد</div>
      <div className={styles["footer"]}>
        <Button
          color="secondary"
          fullWidth
          onClick={onClose}
          size="large"
          variant="contained"
        >
          {replaceSnappTripBasedOnChannel("ورود به اسنپ‌تریپ!")}
        </Button>
      </div>
    </div>
  );
};
